<div class="page-container">
  <div class="page-content">
    <div class="downloadHeaderIcon">
      <svg-icon src="assets/images/icons/projekte_icon.svg" />
    </div>
    <h1 class="h1">Downloads</h1>
    <app-file-list [type]="'downloads'"></app-file-list>
  </div>
</div>
